/* 系统管理->卡口管理 */
<template>
  <div class="kkgl">
    <div class="u-form">
      <template>
        <h4 style="color: aliceblue;margin-top: -30px">
          卡口管理
        </h4>
      </template>
      <car-form @submit="submit" :showformitem="formitem">
        <template>
          <el-button type="success" size="small" @click="add">添加</el-button>
        </template>
      </car-form>
    </div>

    <hy-data-table
      v-model="loading"
      height="94%"
      ref="dataTable"
      @find-page="findPage"
      @detail-handle="detailHandle"
      @img-path="imgPath"
      @del="del"
      is-all-handle
      :data="dataTable.list"
      :columns="dataTable.columns"
      :extend-buttons="dataTable.buttons"
      :show-batch-delete="true"
      :show-operation="true"
      size="medium"
      :paging="dataTable.paging"
      :extend-but-widht="180"
    ></hy-data-table>
  </div>
</template>

<script>
import carForm from "@/components/form/carForm.vue";
import hyDataTable from "@/components/HyDataTable.vue";
import { mapState } from "vuex";
import { requireJson, getdict } from "@/commons/util.js";
export default {
  components: {
    carForm,
    hyDataTable,
  },
  computed: {
    ...mapState({
      boxDetailRerefsh: (state) => state.detail.boxDetailRerefsh,
    }),
  },
  data() {
    return {
      saveAddTemplate: {},

      form: {},
      height: "",
      formitem: [
        "tollgateType", //卡口类型
        "tollgateName", //卡口名称
        "tollgateStatus", //卡口状态
      ],
      loading: false, // 是否加载的标识
      pageRow: 10,
      pageIndex: 1,
      detailList: [
        "卡口编号*",
        "卡口名称*",
        "卡口类型*",
        "卡口位置*",
        "卡口状态*",
        "经度*",
        "纬度*",
        "卡口图片",
        "备注",
      ], //详情修改显示的项目
      dataTable: {
        list: {
          // "status": "S",
          // "msg": "查询成功",
          // "count": 1,
          // "pageIndex": 1,
          // "pageRow": 10,
          // "data": [
          //     {
          //         "num": "123456",
          //         "carNum": "粤S12345",
          //         "time": "2022-02-23 18:28:36",
          //         "vehicleType": "小型蓝牌",
          //         "color": "蓝",
          //         // "picPath": "http://10.0.6.170:8089/{6E015000-A034-45E9-A476-C90751C29585}.jpg",
          //         "pinType": "奥迪A7",
          //         "typeB": "小型客车",
          //         "device": "治安卡口",
          //         "street": "东莞市XX街道XX大道"
          //     }
          // ]
        },
        columns: [
          { prop: "tid", label: "卡口编号", minWidth: 150 },
          { prop: "name", label: "卡口名称", minWidth: 80 },
          { prop: "place", label: "卡口位置", minWidth: 150 },
          { prop: "type", label: "卡口类型", minWidth: 80 },
          { prop: "longitude", label: "经度", minWidth: 60 },
          { prop: "latitude", label: "纬度", minWidth: 60 },
          { prop: "status", label: "卡口状态", minWidth: 80 },
          { prop: "createtor", label: "创建人", minWidth: 70 },
          { prop: "createtime", label: "创建时间", minWidth: 120 },
        ],
        buttons: [
          {
            label: "详情",
            click: "detail-handle",
            perms: 100103,
            // icon: 'fa fa-picture-o',
            type: "primary",
          },
          {
            label: "删除",
            click: "del",
            perms: 100102,
            // icon: 'fa fa-picture-o',
            type: "error",
          },
          {
            label: "图片",
            click: "img-path",
            perms: 100102,
            // icon: 'fa fa-picture-o',
            type: "warning",
          },
        ],
        paging: {
          pageIndex: 1, // 表格分页信息
          pageRow: 10,
          total: 0,
        },
      },
    };
  },
  methods: {
    submit(form) {
      console.log("提交表单", form);
      this.form.name = form.tollgateName;
      this.form.type = form.tollgateType;
      this.form.status = form.tollgateStatus;
      this.pageIndex = 1;
      this.dataTable.paging.pageIndex = 1;
      this.getData();
    },
    findPage(res1) {
      //console.log("findPage", res1);
      this.pageIndex = res1.pageRequest.pageIndex;
      this.getData();
    },
    //添加
    add() {
      const data = this.saveAddTemplate;

      this.$store.commit("boxDetail", {
        data: data,
        title: "新增",
        api: "POST_tollgateAdd",
        uploadImgApi: this.$apis.POST_tollgateImg,
        sort: this.detailList,
      });
    },
    //详情
    detailHandle(res) {
      const data = res.row;
      // console.log("aaaaaaa", data);
      this.$http.GET_tollgateInfo({ paramsID: "/" + data.tid }).then((response) => {
        console.log("详情接口结果", response);
        this.$store.commit("boxDetail", {
          data: response.data,
          title: "详情",
          api: "POST_tollgateUpdata",
          uploadImgApi: this.$apis.POST_tollgateImg,
          sort: this.detailList,
        });
      });
    },
    imgPath(res) {
      if (res.row.img) this.$store.commit("set_dbClickImg", res.row.img);
      else this.$message.warning("没有图片");
    },
    del(res1) {
      console.log("del", res1);
      const data = res1.row;
      this.$confirm('确定要删除吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$http.GET_tollgateDell({ paramsID: "/" + data.tid }).then((response) => {
                this.$message.success("删除成功");
                if (this.dataTable.list.data.length === 1) this.pageIndex = this.pageIndex - 1;
                this.getData();
              });
            }).catch(() => {});
     
    },
    //数据列表
    getData() {
      this.form.pageIndex = this.pageIndex;
      this.form.pageRow = this.pageRow;

      let arr = [];
      this.$http
        .POST_tollgateList(this.form)
        .then((response) => {
          console.log("列表结果", response);
          this.dataTable.paging.total = response.total;
          if (response.data && response.data.length > 0) {
            for (var i = 0; i < response.data.length; i++) {
              const result = this.$myPlug.sortName2cn(response.data[i]);
              arr.push(result);
            }
          }
          this.dataTable.list = {
            pageRow: this.pageRow,
            count: response.total,
            pageIndex: 1,
            data: [],
          };
          this.$set(this.dataTable.list, "data", arr);
          this.saveAddTemplate = JSON.parse(JSON.stringify(this.dataTable.list.data[0]));
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //列表字典转换处理
    dictionaryChage(val, option) {
      let data = "";
      for (let item of option) {
        if (item.code == val) {
          data = item.name;
          break;
        } else {
          data = val;
        }
      }
      return data;
    },
  },
  mounted() {
    //this.getData()
  },
  created() {
    const obj = {};
  },
  watch: {
    boxDetailRerefsh(nval) {
      if (nval) this.getData();
    },
  },
};
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/views/xtgl/kkgl.vue